import React, {useEffect} from "react";

/**
 * @param {string} title
 */
export default function useTitle(title) {
    useEffect(() => {
        document.title = title;
    }, []);
}